// extracted by mini-css-extract-plugin
export default {"notificationList":"style_notificationList__-Li2d"};